// extracted by mini-css-extract-plugin
module.exports = {"container":"__404_container__A65bE","textContainer":"__404_textContainer__w6U5X"};